export default __webpack_public_path__ + "static/media/sim-barcelona.b108a684.jpg";